import React from "react"
import * as styles from "./HeroColumns.module.scss"

type Props = {
  className?: string

  /** Пилюля-тег над заголовком (например «Carrot quest для команд маркетинга»). */
  tag?: React.ReactNode
  date?: React.ReactNode
  /**
   * Машинная дата события в формате с явным часовым поясом,
   * например "2026-04-22T14:00:00+03:00" (Мск).
   * Когда она в прошлом — пилюля с `date` автоматически скрывается
   * (проверяется на этапе сборки).
   */
  eventDate?: string
  title: React.ReactNode
  subTitle?: React.ReactNode

  button?: React.ReactNode
  secondButton?: React.ReactNode
  img?: React.ReactNode
}

const cx = (...c: Array<string | undefined | false>) => c.filter(Boolean).join(" ")

const CalendarIcon: React.FC = () => (
  <svg width="17" height="21" viewBox="0 0 17 21" fill="none" xmlns="http://www.w3.org/2000/svg">
    <path
      d="M15.7992 9.48982C15.3442 8.46573 14.6828 7.54656 13.8563 6.78982L13.1742 6.16403C13.1511 6.14337 13.1232 6.1287 13.093 6.12133C13.0629 6.11395 13.0314 6.11408 13.0013 6.12172C12.9712 6.12936 12.9435 6.14426 12.9205 6.16512C12.8975 6.18599 12.88 6.21217 12.8695 6.24138L12.5648 7.1156C12.375 7.66403 12.0258 8.22419 11.5312 8.77497C11.4984 8.81013 11.4609 8.8195 11.4352 8.82185C11.4094 8.82419 11.3695 8.8195 11.3344 8.78669C11.3016 8.75857 11.2852 8.71638 11.2875 8.67419C11.3742 7.26325 10.9523 5.67185 10.0289 3.93982C9.26484 2.50075 8.20312 1.3781 6.87656 0.595285L5.90859 0.0257535C5.78203 -0.0492465 5.62031 0.0491909 5.62734 0.196847L5.67891 1.32185C5.71406 2.0906 5.625 2.77028 5.41406 3.33513C5.15625 4.02653 4.78594 4.66872 4.3125 5.24528C3.98303 5.64599 3.60959 6.00841 3.19922 6.32575C2.21087 7.08552 1.40722 8.05904 0.848437 9.17341C0.291033 10.2975 0.000680065 11.5351 0 12.7898C0 13.8961 0.217969 14.9672 0.649219 15.9773C1.06562 16.9499 1.66654 17.8326 2.41875 18.5765C3.17813 19.3265 4.05938 19.9172 5.04141 20.3273C6.05859 20.7539 7.13672 20.9695 8.25 20.9695C9.36328 20.9695 10.4414 20.7539 11.4586 20.3297C12.4382 19.9219 13.329 19.3272 14.0812 18.5789C14.8406 17.8289 15.4359 16.9523 15.8508 15.9797C16.2814 14.9723 16.5023 13.8877 16.5 12.7922C16.5 11.6484 16.2656 10.5375 15.7992 9.48982Z"
      fill="#FC7C01"
    />
  </svg>
)

const isEventPast = (eventDate?: string) => {
  if (!eventDate) return false
  const time = Date.parse(eventDate)
  return !Number.isNaN(time) && time < Date.now()
}

export const HeroColumns: React.FC<Props> = ({ className, tag, date, eventDate, title, subTitle, button, secondButton, img }) => {
  const showDate = date && !isEventPast(eventDate)

  return (
    <section className={cx(styles.heroWeb, className)}>
      <div className={styles.heroContent}>
        {tag ? <p className={styles.date}>{tag}</p> : null}

        {showDate ? (
          <p className={styles.date}>
            <CalendarIcon />
            {date}
          </p>
        ) : null}

        <h1 className={styles.heroTitle}>{title}</h1>

        {subTitle ? <p className={styles.heroSubTitle}>{subTitle}</p> : null}

        <div className={styles.heroButtonsWrapper}>
          {button ? <div>{button}</div> : null}
          {secondButton ? <div>{secondButton}</div> : null}
        </div>
      </div>

      {img}
    </section>
  )
}
